import { clsx } from 'clsx';
import { Theme } from '../common/theme.mjs';
import '../common/direction.mjs';
import '../common/propsValues/control.mjs';
import '../common/propsValues/breakpoint.mjs';
import { Size } from '../common/propsValues/size.mjs';
import '../common/propsValues/typography.mjs';
import '../common/propsValues/width.mjs';
import '../common/propsValues/type.mjs';
import '../common/propsValues/dateMode.mjs';
import '../common/propsValues/monthFormat.mjs';
import '../common/propsValues/position.mjs';
import '../common/propsValues/layouts.mjs';
import '../common/propsValues/status.mjs';
import '../common/propsValues/sentiment.mjs';
import '../common/propsValues/profileType.mjs';
import '../common/propsValues/variant.mjs';
import '../common/propsValues/scroll.mjs';
import '../common/propsValues/markdownNodeType.mjs';
import '../common/fileType.mjs';
import '@transferwise/formatting';
import '@transferwise/icons';
import 'react';
import 'react-intl';
import '../common/closeButton/CloseButton.messages.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

const mapLegacySize = {
  16: Size.SMALL,
  24: Size.LARGE,
  // medium is no longer exists, so we map it to small
  [String(Size.MEDIUM)]: Size.SMALL
};
// Note: Badge component is not deprecated, we want stop it's direct usage on consumer side.
// Deprecation notice will hint consumers to migrate. Eventually the component will become internal.
/**
 * @deprecated Use `<AvatarView badge={..} />` instead.
 */
const Badge = ({
  badge,
  className = undefined,
  size: sizeProp = Size.SMALL,
  border = Theme.LIGHT,
  'aria-label': ariaLabel,
  children,
  style
}) => {
  const size = mapLegacySize[sizeProp] ?? sizeProp;
  const classes = clsx('tw-badge', {
    [`tw-badge-border-${border}`]: border,
    [`tw-badge-${size}`]: size
  }, className);
  return /*#__PURE__*/jsxs("div", {
    "aria-label": ariaLabel,
    className: classes,
    style: style,
    children: [/*#__PURE__*/jsx("div", {
      className: "tw-badge__children",
      children: children
    }), /*#__PURE__*/jsx("div", {
      className: "tw-badge__content",
      children: badge
    })]
  });
};

export { Badge as default };
//# sourceMappingURL=Badge.mjs.map
